module.exports = __webpack_public_path__ + "static/img/logo-small.f0303e13.png";